import React, { useMemo } from "react";
import { SlidePnl } from "codekit";

const DOT_COLORS = {
  todos: "#E8472A",
  verde: "#16A34A",
  ambar: "#D97706",
  critico: "#E8472A",
};

const PANEL_TITLES = {
  todos: "Detalle de operaciones",
  verde: "Al día — < 15 días",
  ambar: "En alerta — 15 a 30 días",
  critico: "Crítico — > 30 días",
};

const AGE_STYLES = {
  verde: { bg: "rgba(0,200,150,.15)", color: "#16A34A", border: "rgba(0,200,150,.3)" },
  ambar: { bg: "rgba(245,158,11,.15)", color: "#D97706", border: "rgba(245,158,11,.3)" },
  critico: { bg: "rgba(239,68,68,.15)", color: "#E8472A", border: "rgba(239,68,68,.3)" },
};

const getRange = (days) => {
  if (days < 15) return "verde";
  if (days <= 30) return "ambar";
  return "critico";
};

const AgeBadge = ({ days }) => {
  const s = AGE_STYLES[getRange(days)];
  return (
    <span
      style={{
        display: "inline-flex",
        padding: "2px 8px",
        borderRadius: 20,
        fontSize: 10,
        fontWeight: 700,
        fontFamily: "monospace",
        background: s.bg,
        color: s.color,
        border: `1px solid ${s.border}`,
      }}
    >
      {days}
    </span>
  );
};

const COLUMNS = [
  { label: "DO", key: "DOCNROXX" },
  { label: "NIT", key: "CLIIDXXX" },
  { label: "Cliente", key: "CLINOMXX" },
  { label: "Director", key: "USRNOMXX" },
  { label: "F. Manifiesto", key: "DOCFEMAX" },
  { label: "Levante Esp.", key: "MDIMLEEU" },
  { label: "F. Levante Esp.", key: "MDIMFLEU" },
  { label: "Días", render: (row) => <AgeBadge days={row.EDAD} /> },
];

/**
 * Panel lateral deslizante con detalle paginado de DOs de entrega urgente
 * @author Oscar Rosero <oscar.rosero@repremundo.com.co>
 * @since 2026-05-01
 * @param {boolean} isOpen
 * @param {string} rangeFilter - "todos"|"verde"|"ambar"|"critico"
 * @param {Array} items - lista de DOs del detalle
 * @param {boolean} isLoading
 * @param {function} onClose
 */
const Dtlpanel = ({ isOpen, rangeFilter, items, isLoading, onClose }) => {
  const filtered = useMemo(() => {
    if (rangeFilter === "todos") return items;
    return items.filter((i) => getRange(i.EDAD) === rangeFilter);
  }, [items, rangeFilter]);

  const kpis = useMemo(
    () => [
      { label: "Al día", value: items.filter((i) => getRange(i.EDAD) === "verde").length, color: "#16A34A" },
      { label: "En alerta", value: items.filter((i) => getRange(i.EDAD) === "ambar").length, color: "#D97706" },
      { label: "Crítico", value: items.filter((i) => getRange(i.EDAD) === "critico").length, color: "#E8472A" },
    ],
    [items],
  );

  return (
    <SlidePnl
      isOpen={isOpen}
      onClose={onClose}
      title={PANEL_TITLES[rangeFilter]}
      subtitle="Entrega urgente sin levante definitivo"
      dotColor={DOT_COLORS[rangeFilter]}
      kpis={kpis}
      columns={COLUMNS}
      rows={filtered}
      isLoading={isLoading}
      emptyText="Sin registros para este filtro"
    />
  );
};

export default Dtlpanel;
